import axios from 'axios'

const account = {    
  login: ({email, password, twoFactor, rememberBrowser}) => {
    return axios({
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      },
      withCredentials: true,
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}token`,
      data: `grant_type=password&username=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}&twoFactorCode=${encodeURIComponent(twoFactor)}&rememberBrowser=${encodeURIComponent(rememberBrowser)}`
    }).then(res => res.data)
  },
  signup: data => axios.post(
    `${process.env.REACT_APP_API_URL}account/Register`, data
  ).then(res => res.data),
  confirmEmail: data => axios.post(
    `${process.env.REACT_APP_API_URL}account/ConfirmEmail`, data
  ).then(res => res.data),
  sendConfirmEmail: data => axios.post(
    `${process.env.REACT_APP_API_URL}account/SendConfirmEmail`, data
  ).then(res => res.data),
  sendConfirmText: (data) => axios.post(
    `${process.env.REACT_APP_API_URL}account/SendConfirmText`, data
  ).then(res => res.data),
  forgotPassword: email => axios.post(
    `${process.env.REACT_APP_API_URL}account/ForgotPassword`, email
  ).then(res => res.data),
  resetPassword: data => axios.post(
    `${process.env.REACT_APP_API_URL}account/ResetPassword`, data
  ).then(res => res.data),
  acceptInvitation: data => axios.post(
    `${process.env.REACT_APP_API_URL}account/acceptInvitation`, data
  ).then(res => res.data),
  deleteAccount: () => axios.post(`${process.env.REACT_APP_API_URL}account/DeleteAccount`),
  validateDiscountCode: code => axios.post(
    `${process.env.REACT_APP_API_URL}account/ValidateCode?code=${code}`
  ).then(res => res.data),
  activatePlan: code => axios.post(
    `${process.env.REACT_APP_API_URL}account/ActivatePlan?code=${code}`
  ).then(res => res.data),
  refreshStatus: () => axios.get(
    `${process.env.REACT_APP_API_URL}account/RefreshStatus`
  ).then(res => res.data),
  getUserPhoneMask: () => axios.get(
    `${process.env.REACT_APP_API_URL}account/UserPhoneMask`
  ).then( res => res.data ),
  getSubscriptionInfo: () => axios.get(
    `${process.env.REACT_APP_API_URL}account/SubscriptionInfo`
  ).then( res => res.data ),
  cancelSubscription: () => axios.post(`${process.env.REACT_APP_API_URL}account/CancelSubscription`),
  updateUserPassword: (data) => axios.post(
    `${process.env.REACT_APP_API_URL}account/ChangePassword`, data
  ).then( res => res.data ),
  updateUserEmail: (data) => axios.post(
    `${process.env.REACT_APP_API_URL}account/ChangeEmail`, data
  ).then( res => res.data ),
  updateUserPhone: (data) => axios.post(
    `${process.env.REACT_APP_API_URL}account/ChangePhone`, data
  ).then( res => res.data ),
  sendEmailCode: () => axios.post(
    `${process.env.REACT_APP_API_URL}account/SendEmailCode`
  ).then( res => res.data ),
  getUserDevices: () => axios.get(
    `${process.env.REACT_APP_API_URL}account/UserDevices`
  ).then( res => res.data ),
  lostDevice: (data) => axios.post(
    `${process.env.REACT_APP_API_URL}account/LostDevice`, data
  ).then( res => res.data ),
  confirmLostDevice: data => axios.post(
    `${process.env.REACT_APP_API_URL}account/ConfirmLostDevice`, data
  ).then(res => res.data),
  forgetDevice: (code) => {
    return axios({
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      },
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}account/ForgetDevice`,
      data: `code=${encodeURIComponent(code)}`
    }).then(res => res.data)
  },
  getTwoFactorAuthenticator: () => axios.get(
    `${process.env.REACT_APP_API_URL}account/TwoFactorAuthenticator`
  ).then(res => res.data),
  enableAuthenticator: (type, code) => {
    return axios({
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      },
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}account/EnableAuthenticator`,
      data: `authenticator=${encodeURIComponent(type)}&code=${encodeURIComponent(code)}`
    }).then(res => res.data)
  },
  disableTwoFactor: (code) => {
    return axios({
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      },
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}account/DisableTwoFactor`,
      data: `code=${encodeURIComponent(code)}`
    }).then(res => res.data)
  },
  getQRCode: type => axios.get(
    `${process.env.REACT_APP_API_URL}account/QRCode?authenticator=${type}`
  ).then( res => res.data ),
}

export default account